"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tavagnacco": {
    "82df7009": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "skipSearch": false
    }],
    "feletto-umberto-adegliacco-cavalicco": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b64d7e0": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "skipSearch": false
    }],
    "adegliacco": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "42a3b217": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "skipSearch": false
    }],
    "cavalicco": [{
      "hkey": "60439f2c",
      "slug": "feletto-umberto",
      "name": "Feletto Umberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;